export const FlooringTypes: string[] = [
  'Hardwood',
  'Luxury Vinyl',
  'Laminate',
  'Carpet',
  'Natural Stone',
  'Tile',
  'Waterproof Flooring',
  'Glass Tile',
  'Metal Tile',
  'Solid Surface',
  'Vinyl', // Alias for Vinyl Sheet Goods
  'Vinyl Sheet Goods',
  'Carpet Tile',
  'Area Rugs',
  'Cork',
];

const BathingTypes = [
  'bathing.bathtub',
  'bathing.screen',
  'bathing.wall',
  'bathing.panel',
  'bathing.feet',
  'bathing.cradle',
  'bathing.grip',
  'bathing.bathtub.kit',
];

const CabinetryTypes = [
  'cabinetry.cabinet',
  'cabinetry.front',
  'cabinetry.filler',
  'cabinetry.handle',
  'cabinetry.hardware',
  'cabinetry.molding',
  'cabinetry.panel',
];

const WorktopTypes = [
  'worktop',
  'worktop.slab',
  'worktop.precut',
  'worktop.backsplash',
  'worktop.backsplash.precut',
  'worktop.cutout',
  'worktop.edge',
  'worktop.edgeCut',
  'worktop.joint',
  'worktop.wallStrip',
  'worktop.waterfall',
  'worktop.integratedSink',
  'worktop.component',
];

export const ProductTypes: string[] = [
  ...BathingTypes,
  ...CabinetryTypes,
  ...FlooringTypes,
  ...WorktopTypes,
];

export type ProductType = (typeof ProductTypes)[number];

/**
 * CiC `baseItemType` prefixes that identify kitchen, bath & fixture (KB&F)
 * catalog items, as opposed to flooring (`covering.*`).
 */
export const KbfBaseItemTypePrefixes = ['bathing', 'cabinetry', 'worktop'];

/**
 * Whether a product should render with the KB&F product page (3D viewer and
 * configurator) rather than the flooring one.
 *
 * `productTypeSlug` carries the raw CiC `baseItemType` (e.g.
 * `cabinetry.cabinet`), which is the reliable signal; `productType` is the
 * title-cased last segment (`Cabinet`) and is only consulted when no slug is
 * available, in which case anything that is not a known flooring type counts.
 */
export const isKbfProductType = (product: {
  productType?: string;
  productTypeSlug?: string;
}): boolean => {
  const slug = product.productTypeSlug?.toLowerCase() ?? '';
  if (slug) {
    const root = slug.split('.')[0];
    if (KbfBaseItemTypePrefixes.includes(root)) return true;
    if (root === 'covering' || root === 'accessory') return false;
  }
  const type = product.productType ?? '';
  if (!type) return false;
  return !FlooringTypes.some((f) => f.toLowerCase() === type.toLowerCase());
};
